/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Button } from '@mui/material';

import { i18n as i18nPromise } from '../i18n';
import { store } from '../store';
import { closeSnackbar, enqueueSnackbar } from '../store/notifier/actions';
import { ReportableApiError } from './ReportableApiError';

export const notifyReportableApiError = async (error: unknown) => {
  const i18n = await i18nPromise;

  store.dispatch(
    enqueueSnackbar(<ReportableApiError error={error as any} />, {
      persist: true,
      variant: 'error',
      action: snackbarId => (
        <Button style={{ color: '#fff' }} onClick={() => store.dispatch(closeSnackbar(snackbarId))}>
          {i18n.t<string>('common:reportable_error.dismiss')}
        </Button>
      ),
    }),
  );
};
